export const interpolate = (
  text: string,
  params: Record<string, unknown> = {}
): string => {
  return text.replace(/\{([^}]+)\}/g, (match, expression) => {
    try {
      if (expression.includes('?')) {
        const [condition, values] = expression.split('?');
        const [trueValue, falseValue] = values.split(':');

        const conditionMatch = condition.trim().match(/(\w+)\s*===\s*(\d+)/);
        if (conditionMatch && Object.prototype.hasOwnProperty.call(params, conditionMatch[1])) {
          const result = params[conditionMatch[1]] == parseInt(conditionMatch[2]);
          return result ? trueValue.trim().replace(/"/g, '') : falseValue.trim().replace(/"/g, '');
        }
      }

      if (Object.prototype.hasOwnProperty.call(params, expression)) {
        return String(params[expression]);
      }

      return match;
    } catch (error) {
      console.warn(`Error evaluating expression: ${expression}`, error);
      return match;
    }
  });
};
